import script from "./CallDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CallDialog.vue?vue&type=style&index=0&id=3fcc1e82&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fcc1e82"]])

export default __exports__